export default {
  state: {
    visible: false,
    id: '',
    status: '',
    ext: ''
  },

  mutations: {
    changePopupVisible (state, obj) {
      state.id = obj.id || ''
      state.visible = obj.visible
      state.status = obj.status || ''
      state.ext = obj.ext || ''
    },

    closePopup (state) {
      state.visible = false
    }
  },

  actions: {
    initPopupCode ({ commit }) {
      const hadPopup = localStorage.getItem('had-popup-code')
      if (!hadPopup) {
        setTimeout(() => {
          commit('changePopupVisible', { visible: true, status: 'code' })
        }, 1000)

        localStorage.setItem('had-popup-code', true)
      }
    }
  }
}